////////////*Feature:Positive Feedback Function///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 *
 */
function initFeedbacks() {
	var modalContainer = $('.si-modal-container__js');
	var modals = $('.si-modal__js');
	var modalClosers = $('.si-modal-closer__js');

	modals.on('click.prevent', function (e) {
		var isHotspotModal = globalVar.currentModalType === 'hotspot';
		var hotspot = slides[globalVar.curSlide].hotspot;
		var clickAnywhereHotspot = hotspot && hotspot.modals && hotspot.modals.clickAnywhere;

		if (e.target.tagName !== 'A') e.preventDefault();

		if (!(isHotspotModal && clickAnywhereHotspot)) e.stopPropagation();
	});
	modalContainer.on('click.close', function () {
		modalClosingActions();
	});
	modalClosers.each(function (idx, closer) {
		$(closer).on('click.close', function (e) {
			e.stopPropagation();
			modalClosingActions();
		});
	});
}

/**
 *
 */
function answerCorrect() {
	var currentModal = slides[globalVar.curSlide].modal.positive;
	var modalContainer = $('.si-modal-container__js');
	$('.leader-line').addClass('hide');
	modalContainer.addClass('si-modal-container-open');
	$('#' + currentModal).addClass('si-current-modal');
	globalVar.currentModal = currentModal;
	globalVar.currentModalType = 'positive';
	var type = slides[globalVar.curSlide].type;
	slides[globalVar.curSlide][type].trys = 0;
	if (siAudio[globalVar.curSlide].positive) {
		siAudio.sfx.right.once('end', function () {
			siAudio[globalVar.curSlide].positive.play();
		});
		siAudio.sfx.right.play();
	} else {
		siAudio.sfx.right.play();
	}

	slideAction(globalVar.curSlide, 'onSuccessAction');
}

////////////*Feature:Negative Feedback Functions///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 *
 */
function answerIncorrect() {
	var slide = globalVar.slide;

	var type = slide.data.type;
	var trys = slide.data[type].trys;
	var attempts = slide.data[type].userAttempts;
	var modalContainer = $('.si-modal-container__js');
	if (attempts === 0) {
		trys = 0;
	} else {
		trys++;
	}
	slide.data[type].trys = trys;

	if (trys < attempts || attempts === 0) {
		var currentModal;
		if (slide.data.modal['negative' + trys]) {
			currentModal = slide.data.modal['negative' + trys];
			globalVar.currentModal = currentModal;
			globalVar.currentModalType = 'negative' + trys;
		} else if (slide.data.modal.negative) {
			currentModal = slide.data.modal.negative;
			globalVar.currentModal = currentModal;
			globalVar.currentModalType = 'negative';
		}
		$('.leader-line').addClass('hide');
		modalContainer.addClass('si-modal-container-open');
		$('#' + currentModal).addClass('si-current-modal');
		if (siAudio[slide.id]['negative' + trys]) {
			siAudio.sfx.wrong.once('end', function () {
				siAudio[slide.id]['negative' + trys].play();
			});
			siAudio.sfx.wrong.play();
		} else if (siAudio[slide.id].negative) {
			siAudio.sfx.wrong.once('end', function () {
				siAudio[slide.id].negative.play();
			});
			siAudio.sfx.wrong.play();
		} else {
			siAudio.sfx.wrong.play();
		}

		slideAction(slide.id, 'onFailureAction1');
	} else if (attempts !== 0 && trys === attempts) {
		currentModal = slide.data.modal.negativeFinal;
		globalVar.currentModal = currentModal;
		globalVar.currentModalType = 'negativeFinal';
		$('.leader-line').addClass('hide');
		modalContainer.addClass('si-modal-container-open');
		$('#' + currentModal).addClass('si-current-modal');
		slide.data[type].trys = 0;

		if (siAudio[slide.id].negativeFinal) {
			siAudio.sfx.wrong.once('end', function () {
				siAudio[slide.id].negativeFinal.play();
			});
			siAudio.sfx.wrong.play();
		} else {
			siAudio.sfx.wrong.play();
		}

		slideAction(slide.id, 'onFailureAction2');
	}
}
////////////*Feature:Positive and Negative Feedback Handler & closeFeedbackAction///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * @param bol
 */
function handleAnswer(bol) {
	var slide = globalVar.slide;
	var type = slide.data.type;
	var trys = slide.data[type].trys;
	var modalType = bol ? 'positive' : 'negative';
	var hasModal =
		slide.data.modal &&
		(slide.data.modal[modalType] || slide.data.modal[modalType + 'Final'] || slide.data.modal[modalType + trys]);

	Howler.stop();

	if (bol) {
		if (globalVar.earnCoins === true && slide.data.coinSettings.include) {
			addCoins();
		}
	}

	if (!hasModal) {
		if (bol) {
			slideAction(slide.id, 'onSuccessAction');
		} else {
			slideAction(slide.id, 'onFailureAction1');
		}
		slideAction(slide.id, 'nextAction');
	} else {
		// $('#si-nav-container').addClass('feedback-open');
		if (bol == true) {
			answerCorrect();
		} else {
			answerIncorrect();
		}
	}
}

/**
 * @param item
 */
function closeFeedbackAction(item) {
	var slide = globalVar.slide;
	$('.leader-line').removeClass('hide');
	switch (item) {
		case 'positive':
			slideAction(slide.id, 'nextAction');
			break;
		case 'negative':
			break;
		case 'hotspot':
			var $hotspots = slide.$.find(' .hotspot-button__js');
			var itemNum = globalVar.hotspotItemNum;
			var $hotspot = $($hotspots[itemNum - 1]);
			var $curModal = $('#' + globalVar.currentModal);
			var modals = getHotspotModals($hotspots.length);

			handleHotspotClose(slide.data.hotspot, $hotspots, modals, itemNum, $hotspot, $curModal);

			break;
		case 'negativeFinal':
			slideAction(slide.id, 'nextAction');
			break;
		default:
			break;
	}
}

/**
 *
 */
function FBKeyboard() {
	// var key = $("#FBKey")
	var FBitems = $('.si-current-modal').children().children();
	var idx;
	if ($(FBitems[0]).hasClass('ie9hack')) {
		idx = 1;
	} else {
		idx = 0;
	}
	$(FBitems[idx]).focus();

	$('body').on('keydown.drag', function (event) {
		switch (event.keyCode) {
			case 9: //cycles through only FB elements while it is open
				event.preventDefault();
				if (idx < FBitems.length - 1) {
					idx += 1;
				} else {
					idx = 0;
				}
				$(FBitems[idx]).focus();
				break;
			case 27: // allows user to press escape key to return to normal and places focus on previous element
				$('.si-current-modal').trigger('click');
				$(document.activeElement).blur();
				break;
			case 13: // allows user to press enter key to return to normal and removes all focus (so that submit key is not clicked when FB closes)
				$('.si-current-modal').trigger('click');
				$(document.activeElement).blur();
				break;
			default:
				return true;
		}
	});
}

/**
 *
 */
function handleHotspotClose(settings, $hotspots, modals, itemNum, $hotspot, $modal) {
	var itemSettings = getItemSettings(settings.items, $hotspot[0].id, itemNum);

	hotspotCustomAction(settings.onModalClose, itemSettings && itemSettings.onModalClose, $hotspot, $modal);

	hotspotItemComplete(settings, $hotspots, itemSettings, $hotspot, $modal);

	if (settings.linear)
		hotspotUnlockNext(settings, $hotspots, itemNum + 1, $($hotspots[itemNum]), modals && modals[itemNum]);
}

/**
 * @param container
 */
function modalClosingActions() {
	var slide = globalVar.slide;
	Howler.stop();
	if (slide.data.type === 'hotspot' && slide.data.hotspot.modals && slide.data.hotspot.modals.hover) {
		// console.log('hover-hotspot, no click audio');
	} else {
		siAudio.sfx.click.play();
	}

	var isFeedbackModal = globalVar.currentModalType && globalVar.currentModalType !== 'hotspot';

	switch (isFeedbackModal && slide.data.type) {
		case 'dnd':
			resetDnd();
			break;
		case 'sort':
			resetSort();
			break;
		case 'quiz':
			resetQuiz();
			break;
		case 'scratch':
			resetScratch();
			break;
		case 'hotspot':
			var $hotspots = slide.$.find(' .hotspot-button__js');

			resetHotspot(slide.data.hotspot, $hotspots, getHotspotModals($hotspots.length));
			break;
		default:
			if (slide.data.customReset) {
				slide.data.customReset();
			}
	}
	if (slide.data[slide.data.type].customReset) {
		slide.data[slide.data.type].customReset();
	}

	$('body').off('keydown.drag');

	$('.si-modal-container__js').removeClass('si-modal-container-open si-hover-hotspot');
	// console.log($('#' + globalVar.currentModal));
	$('#' + globalVar.currentModal).removeClass('si-current-modal');
	closeFeedbackAction(globalVar.currentModalType);
}

/**
 * @param id
 */
function simpleModalOpen(id) {
	if (slides[globalVar.curSlide].modal[id]) {
		var currentModal = slides[globalVar.curSlide].modal[id];
		if (siAudio[globalVar.curSlide][id]) {
			siAudio[globalVar.curSlide][id].play();
		}
		$('.si-modal-container__js').addClass('si-modal-container-open');
		$('#' + currentModal).addClass('si-current-modal');
		globalVar.currentModal = currentModal;
	}
}

/**
 *
 */
function simpleModalClose() {
	Howler.stop();
	$('.si-modal-container__js').removeClass('si-modal-container-open');
	$('#' + globalVar.currentModal).removeClass('si-current-modal');
}
